import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueResource from "vue-resource";
import axios from "axios";
import VueTouch from "vue-touch";

Vue.use(VueTouch, {
  name: 'v-touch'
});
Vue.prototype.$axios = axios;
Vue.config.productionTip = true;
Vue.use(VueResource);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");